export const Tier3PassiveCollectibles = [
    ['The Sad Onion', '1'],
    ['Spoon Bender', '3'],
    ['Blood of the Martyr', '7'],
    ['Skeleton Key', '17'],
    ['A Dollar', '18'],
    ['Transcendence', '20'],
    ['Wire Coat Hanger', '32'],
    ['Cupid\'s Arrow', '48'],
    ['Steven', '50'],
    ['Pentagram', '51'],
    ['Technology', '68'],
    ['Chocolate Milk', '69'],
    ['Growth Hormones', '70'],
    ['The Mark', '79'],
    ['The Pact', '80'],
    ['Dead Cat', '81'],
    ['Lord of the Pit', '82'],
    ['The Small Rock', '90'],
    ['The Relic', '98'],
    ['The Parasite', '104'],
    ['Money = Power', '109'],
    ['Mom\'s Contacts', '110'],
    ['A Lump of Coal', '132'],
    ['Mom\'s Purse', '139'],
    ['Tough Love', '150'],
    ['The Mulligan', '151'],
    ['Mutant Spider', '153'],
    ['Bloody Lust', '157'],
    ['Spirit of the Night', '159'],
    ['Cat-O-Nine-Tails', '165'],
    ['Daddy Longlegs', '170'],
    ['Mitre', '173'],
    ['Holy Water', '178'],
    ['Fate', '179'],
    ['Toothpicks', '183'],
    ['Holy Grail', '184'],
    ['Dead Dove', '185'],
    ['SMB Super Fan', '189'],
    ['Pyro', '190'],
    ['Squeezy', '196'],
    ['Mom\'s Key', '199'],
    ['Humbling Bundle', '203'],
    ['Champion Belt', '208'],
    ['Goat Head', '215'],
    ['Ceremonial Robes', '216'],
    ['Mom\'s Wig', '217'],
    ['Rubber Cement', '221'],
    ['Cricket\'s Body', '224'],
    ['Abaddon', '230'],
    ['Death\'s Touch', '237'],
    ['Contract From Below', '241'],
    ['Trinity Shield', '243'],
    ['Tech.5', '244'],
    ['There\'s Options', '249'],
    ['Screw', '255'],
    ['Dark Matter', '259'],
    ['Black Candle', '260'],
    ['Dry Baby', '265'],
    ['Rotten Baby', '268'],
    ['Lil Brimstone', '275'],
    ['Dark Bum', '278'],
    ['Cancer', '301'],
    ['Scorpio', '305'],
    ['Sagittarius', '306'],
    ['Capricorn', '307'],
    ['Judas\' Shadow', '311'],
    ['Mysterious Liquid', '317'],
    ['The Mind', '333'],
    ['The Body', '334'],
    ['The Soul', '335'],
    ['Dead Onion', '336'],
    ['Torn Photo', '341'],
    ['Blue Cap', '342'],
    ['Synthoil', '345'],
    ['Toxic Shock', '350'],
    ['Car Battery', '356'],
    ['8 Inch Nails', '359'],
    ['Sworn Protector', '363'],
    ['Mr. Dolly', '370'],
    ['Charged Baby', '372'],
    ['Dead Eye', '373'],
    ['Holy Light', '374'],
    ['Host Hat', '375'],
    ['Eden\'s Blessing', '381'],
    ['Censer', '387'],
    ['Rune Bag', '389'],
    ['Seraphim', '390'],
    ['Tractor Beam', '397'],
    ['Chaos', '402'],
    ['Purity', '407'],
    ['Lusty Blood', '411'],
    ['More Options', '414'],
    ['Succubus', '417'],
    ['Sack Head', '424'],
    ['Binky', '438'],
    ['Apple!', '443'],
    ['Lead Pencil', '444'],
    ['Compound Fracture', '453'],
    ['Belly Button', '458'],
    ['Sinus Infection', '459'],
    ['Parasitoid', '461'],
    ['Eye of Belial', '462'],
    ['Glyph of Balance', '464'],
    ['Jacob\'s Ladder', '494'],
    ['Ghost Pepper', '495'],
    ['Euthanasia', '496'],
    ['Eucharist', '499'],
    ['Sack of Sacks', '500'],
    ['Little Horn', '503'],
    ['Jumper Cables', '520'],
    ['Technology Zero', '524'],
    ['Angelic Prism', '528'],
    ['Haemolacria', '531'],
    ['Schoolbag', '534'],
    ['Dad\'s Ring', '546'],
    ['Divorce Papers', '547'],
    ['Brittle Bones', '549'],
    ['Mucormycosis', '553'],
    ['Rock Bottom', '562'],
    ['A Bar of Soap', '564'],
    ['Paschal Candle', '567'],
    ['Playdough Cookie', '570'],
    ['Eye of the Occult', '572'],
    ['Immaculate Heart', '573'],
    ['The Intruder', '575'],
    ['Spirit Sword', '579'],
    ['The Stairway', '586'],
    ['Mercurius', '590'],
    ['Terra', '592'],
    ['Uranus', '596'],
    ['Neptunus', '597'],
    ['Pluto', '598'],
    ['Eye Drops', '600'],
    ['Act of Contrition', '601'],
    ['Ocular Rift', '606'],
    ['Bird\'s Eye', '616'],
    ['Lodestone', '617'],
    ['Birthright', '619'],
    ['Bot Fly', '629'],
    ['Knockout Drops', '637'],
    ['Brimstone Bombs', '646'],
    ['Star of Bethlehem', '651'],
    ['Card Reading', '660'],
    ['Sausage', '669'],
    ['Lil Abaddon', '679'],
    ['Montezuma\'s Revenge', '680'],
    ['Worm Friend', '682'],
    ['Hungry Soul', '684'],
    ['Belly Jelly', '690'],
    ['Heartbreak', '694'],
    ['Bloody Gust', '695'],
    ['Salvation', '696'],
    ['Vanishing Twin', '697'],
    ['Azazel\'s Rage', '699'],
    ['Isaac\'s Tomb', '701'],
    ['Stapler', '708'],
    ['Keeper\'s Sack', '716'],
    ['Hypercoagulation', '724'],
    ['Glass Eye', '730'],
    ['Mom\'s Ring', '732'],
];